<template>
  <div>
    <input :id="id" type="hidden" name="content" v-model="trixText">
    <trix-editor ref="trix" :input="id" class="trix-editor"></trix-editor>
  </div>
</template>

<script>
import Trix from 'trix'
import 'trix/dist/trix.css'

export default {
  props: ["id", "text"],
  data() {
    return {
      trixText: this.text,
    };
  },
  methods: {
    setTextToTrix(e) {
      this.trixText = document.getElementById(this.id).value;
    },
    emitDataBackToComponent() {
      this.$emit("dataFromTrix", this.trixText);
    }
  },
  mounted() {
    this.$refs.trix.innerHTML = this.trixText;
    document.addEventListener("trix-change", this.setTextToTrix);
  },
  beforeUnmount: function() {
    document.removeEventListener("trix-change", this.setTextToTrix);
  },
  updated() {
    this.emitDataBackToComponent();
  },
};
</script>
<style>
.trix-button-group.trix-button-group--file-tools {
  display:none;
}
</style>